import { render, staticRenderFns } from "./CvIntro.vue?vue&type=template&id=2d0874fe&"
import script from "./CvIntro.vue?vue&type=script&lang=js&"
export * from "./CvIntro.vue?vue&type=script&lang=js&"
import style0 from "./CvIntro.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports